import React, { useContext, useState } from 'react';
import "./FoodItem.css";
import { food_list } from '../../assets/assets';

import { assets } from '../../assets/assets';
import { StoreContext } from '../../context/StoreContext';


const FoodItem = ({ id, name, price, description, image }) => {


    
    
    
    
    // Updated image path that points to the upload that recieves from server
   
   // Updated image path
    
 



    const {cartItems,addToCart,removeFromCart,url} = useContext(StoreContext);

    return (
        <div className='food-item'>
            <div className="food-item-img-container">
                <img className="food-item-img" src={url+"/images/"+image} alt="OfficeBites.store Order from office, get Pre-packaged office snacks

OfficeBites offers Customized snack delivery in Meru town

Get Affordable corporate snack plans to motivate your team, OfficeBites will support you.

Enjoy fast snack delivery for offices with OfficeBites.store

Get Subscription-based snack delivery with OfficeBites, get your more for your money, OfficeBites is the better option.

Healthy snack bundles for offices from officebites.store" />

                {!cartItems[id] ?
                    <img className="add" onClick={() =>addToCart(id)} src={assets.add_icon_white} alt='Office Bites Order Snacks Delivery' />
                    :
                    <div className='food-item-counter'>
                        <img onClick={() =>removeFromCart(id)} src={assets.remove_icon_red} alt="Office Bites Order Free Delivery" />
                        <p>{cartItems[id]}</p>
                        <img onClick={() =>addToCart(id)} src={assets.add_icon_green} alt="Office Bites Order Free Delivery" />
                    </div>
                }
            </div>

            <div className="food-item-info">
                <div className="food-item-name-rating">
                    <p>{name}</p>
                    <img src={assets.rating_starts} alt="" />
                </div>

                <p className="food-item-desc">{description}</p>
                <p className="food-item-price">Ksh {price}</p>
            </div>
        </div>
    );
};

export default FoodItem;